import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import CallMadeIcon from "@mui/icons-material/CallMadeRounded";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";
import NumbersRoundedIcon from "@mui/icons-material/NumbersRounded";
import PercentRoundedIcon from "@mui/icons-material/PercentRounded";
import TitleIcon from "@mui/icons-material/TitleRounded";
import type { SvgIconProps } from "@mui/material";
import MoneyIcon from "@entrilia/shared/icons/MoneyIcon";
import SelectIcon from "@entrilia/shared/icons/SelectIcon";
import type { EntityFieldType } from "../../../api/types/objectTypes";
import CheckboxFieldTypeIcon from "@entrilia/shared/icons/CheckboxFieldTypeIcon";
import KeyVerticalIcon from "@entrilia/shared/icons/KeyVerticalIcon";
import MultiSelectIcon from "@entrilia/shared/icons/MultiSelectIcon";

interface Props extends SvgIconProps {
  fieldType: EntityFieldType;
}

const FieldIcon = ({ fieldType, ...iconProps }: Props) => {
  switch (fieldType) {
    case "Text": {
      return <TitleIcon {...iconProps} />;
    }
    case "Email": {
      return <MailOutlineRoundedIcon {...iconProps} />;
    }
    case "Phone": {
      return <LocalPhoneRoundedIcon {...iconProps} />;
    }
    case "Url": {
      return <LanguageRoundedIcon {...iconProps} />;
    }
    case "Number": {
      return <NumbersRoundedIcon {...iconProps} />;
    }
    case "Money": {
      return <MoneyIcon {...iconProps} />;
    }
    case "Percent": {
      return <PercentRoundedIcon {...iconProps} />;
    }
    case "Select":
    case "UserDefinedOptionsSelect": {
      return <SelectIcon {...iconProps} />;
    }
    case "MultiSelect":
    case "UserDefinedOptionsMultiSelect": {
      return <MultiSelectIcon {...iconProps} />;
    }
    case "Date":
    case "DateTime": {
      return <CalendarTodayRoundedIcon {...iconProps} />;
    }
    case "Checkbox": {
      return <CheckboxFieldTypeIcon {...iconProps} />;
    }
    case "Lookup":
    case "MultiLookup": {
      return <CallMadeIcon {...iconProps} />;
    }
    case "Guid": {
      return <KeyVerticalIcon {...iconProps} />;
    }
    default: {
      return null;
    }
  }
};

export default FieldIcon;
